var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcToiletDoorUnknown = function SvgIcToiletDoorUnknown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    fill: "none",
    viewBox: "0 0 33 33"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 4.25,
    y: 4.465,
    fill: "#fff",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 4.25,
    y: 4.465,
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 2.667,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.645 21.436a1.6 1.6 0 1 1-3.2 0 1.6 1.6 0 0 1 3.2 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.022 12.278c-.536 0-.996.16-1.32.388-.312.221-.467.478-.511.7a1.16 1.16 0 0 1-2.274-.46c.181-.9.74-1.636 1.447-2.136.736-.52 1.669-.812 2.658-.812 2.045 0 4.166 1.367 4.166 3.564 0 1.272-.756 2.301-1.735 2.901a1.16 1.16 0 0 1-1.211-1.98c.456-.278.626-.634.626-.92 0-.46-.572-1.245-1.846-1.245",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.02 15.37c.64 0 1.16.518 1.16 1.16v1.201a1.16 1.16 0 1 1-2.32 0V16.53c0-.64.519-1.16 1.16-1.16",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.843 14.838a1.16 1.16 0 0 1-.4 1.592l-1.828 1.094a1.16 1.16 0 0 1-1.192-1.99l1.828-1.095a1.16 1.16 0 0 1 1.592.4",
    clipRule: "evenodd"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 4.25,
    y: 4.465,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    rx: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 4.25,
    y: 4.465,
    fill: "#fff",
    rx: 4
  })))));
};
export default SvgIcToiletDoorUnknown;